import { type MouseEvent, useCallback } from "react";
import { Icon, Tooltip } from "@mui/material";
import cx from "classnames";
import { PitIcon } from "@ui-icons";
import { ALL_TASKS } from "../../TaskSelector.constants";
import type { TaskSelectorDefaultRenderOptionProps } from "../../TaskSelector.types";

const TaskSelectorDefaultRenderOption = ({
  option,
  onClick,
  disabledUnclickable,
  app_pit,
  ...props
}: TaskSelectorDefaultRenderOptionProps) => {
  const onLocalClick = useCallback(
    (e: MouseEvent<HTMLLIElement>) => {
      if (!option.disabled || !disabledUnclickable) {
        onClick?.(e, option);
      }
    },
    [onClick, option]
  );

  return (
    <li
      {...props}
      className={cx(props.className, {
        "opacity-50": option.disabled && disabledUnclickable,
      })}
      onClick={onLocalClick}
    >
      <div className="flex items-center gap-2">
        {!option.disabled && option.task_name !== ALL_TASKS && app_pit ? (
          <Tooltip
            title="This task ran in the selected PIT"
            arrow
            disableInteractive
          >
            <PitIcon fontSize="small" color="disabled" />
          </Tooltip>
        ) : app_pit ? (
          <Icon fontSize="small" />
        ) : null}
        <span className="relative z-10">{option.task_name}</span>
      </div>
    </li>
  );
};

export default TaskSelectorDefaultRenderOption;
